import { COLORS } from '@repo/design-system/index'
import { QIcon_check_mark, QIcon_plus_default } from '@repo/icons/index'

interface FilterChipProps {
  id: string
  name: string
  checked: boolean
  onClick: (id: string) => void
  showIcon?: boolean
}

const FilterChip = ({ id, name, checked, onClick, showIcon = true }: FilterChipProps) => {
  return (
    <div className="flex gap-x-8">
      <button
        key={id}
        className={`flex-shrink-0 p-8 pl-10 flex gap-x-4 items-center border-[1.5px] rounded-[8px] ${
          checked ? 'bg-purple-50 border-purple-500' : 'bg-white border-gray-300'
        }`}
        onClick={() => onClick(id)}
      >
        <span className={`Body2-14Md ${checked ? 'text-purple-500' : ''}`}>{name}</span>

        {showIcon ? (
          <>
            {checked ? (
              <QIcon_check_mark width={14} height={14} color={COLORS.PURPLE500} />
            ) : (
              <QIcon_plus_default width={14} height={14} color={COLORS.GRAY300} />
            )}
          </>
        ) : (
          <></>
        )}
      </button>
    </div>
  )
}

export default FilterChip
